





















































































import { Vue, Component } from 'vue-property-decorator'

import { cloneDeep } from 'lodash'

import { BtnList } from '@/types/common/btn'
import { RateListMap } from '@/types/newPersion'

import { saveNewPersion, getNewPersionList } from '../../../utils'

import FormItem from '@/components/formItem/index.vue'

import BaseInfo from '../../../components/baseInfo/index.vue'
import NewFooter from '../../../components/newFooter'
import { inputForm, btnList } from '../utils'
@Component({
  components: { BaseInfo, FormItem, NewFooter },
})
export default class extends Vue {
  dialogShow = false;
   propData: {title: string; name: string}[] =[]
  // 输入表单
  form = inputForm;

  formClone = inputForm;

  // 底部按钮数组
  btnList = btnList;

  rateList: RateListMap[] = [];
  async created () {
    const res = await await getNewPersionList()
    this.form = cloneDeep(res)
    this.propData = [{
      title: '预计退休年龄',
      name: res.retireAge + '岁'
    }, {
      title: '预计养老金领取年限',
      name: res.deathAge + '年'
    }]
    this.formClone = res
  }

  private nextPage (item: BtnList) {
    const { btnType } = item
    switch (btnType) {
      case 'reset':
        this.form = this.formClone
        break
      case 'confirm':
      default:
        this.handleConfirm()
        break
    }
  }

  private async handleConfirm () {
    const res = await saveNewPersion(this.form as {})
    if (res) {
      this.$emit('on-click', 'output')
    }
  }

  private handleFormItemLabelBtn () {
    this.dialogShow = true
  }

  private handleBaseInfoBtn (type: string) {
    this.$router.push('/pension/card/' + type)
  }

  private handleDialogClose () {
    this.dialogShow = false
  }
}
